// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarControls_wrap__JXA3z {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.CalendarControls_row__JBXw1 {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
}

.CalendarControls_label__1qaUY {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
  min-width: 48px;
}

.CalendarControls_toggle__hJxOb {
  padding: 4px 12px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 14px;
  cursor: pointer;
  font-size: 12px;
  color: #838383;
}
.CalendarControls_toggle__hJxOb:hover:not(.CalendarControls_toggleActive__dpDa3) {
  background: #f4f5f7;
}

.CalendarControls_toggleActive__dpDa3 {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  font-weight: 600;
}

.CalendarControls_pillStrip__MF33G {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.CalendarControls_pill__aaySI {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 56px;
  padding: 4px 8px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  cursor: pointer;
  transition: background 0.1s ease, border-color 0.1s ease, transform 0.1s ease;
}
.CalendarControls_pill__aaySI:hover:not(:disabled):not(.CalendarControls_active__dBlIg) {
  background: #f4f5f7;
  border-color: #acacac;
}
.CalendarControls_pill__aaySI:disabled {
  cursor: default;
  opacity: 0.45;
}

.CalendarControls_active__dBlIg {
  background: var(--primary-color);
  border-color: var(--primary-color);
  transform: translateY(-1px);
}
.CalendarControls_active__dBlIg .CalendarControls_pillLabel__ilmvj {
  color: #fff;
}
.CalendarControls_active__dBlIg .CalendarControls_pillCount__\\+TTJ5 {
  color: rgba(255, 255, 255, 0.85);
}

.CalendarControls_pillLabel__ilmvj {
  font-size: 12px;
  font-weight: 600;
  color: #838383;
  line-height: 1;
}

.CalendarControls_pillCount__\\+TTJ5 {
  font-size: 10px;
  font-family: monospace;
  color: #acacac;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/CalendarControls/CalendarControls.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,QCGS;ADLX;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QCHS;EDIT,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cEbS;EFcT,eAAA;AAFF;;AAOA;EACE,iBAAA;EACA,gBEfM;EFgBN,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cEzBS;AFqBX;AAME;EACE,mBE/BO;AF2BX;;AAQA;EACE,gCE1CQ;EF2CR,kCE3CQ;EF4CR,WE9BM;EF+BN,gBAAA;AALF;;AAUA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBEjDM;EFkDN,yBAAA;EACA,kBC/Dc;EDgEd,eAAA;EACA,6EAAA;AAPF;AASE;EACE,mBEhEO;EFiEP,qBE/DO;AFwDX;AAUE;EACE,eAAA;EACA,aAAA;AARJ;;AAYA;EACE,gCEjFQ;EFkFR,kCElFQ;EFmFR,2BAAA;AATF;AAWE;EAAa,WEvEP;AF+DR;AASE;EAAa,gCAAA;AANf;;AASA;EACE,eAAA;EACA,gBAAA;EACA,cEnFS;EFoFT,cAAA;AANF;;AASA;EACE,eAAA;EACA,sBAAA;EACA,cE3FS;EF4FT,cAAA;AANF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.wrap {\n  display: flex;\n  flex-direction: column;\n  gap: $margin-s;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: $margin-s;\n  flex-wrap: nowrap;\n}\n\n.label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n  min-width: 48px;\n}\n\n// ─── View toggle (Year / Month) ──────────────────────────────────────────────\n\n.toggle {\n  padding: 4px 12px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: 14px;\n  cursor: pointer;\n  font-size: 12px;\n  color: $grey-400;\n\n  &:hover:not(.toggleActive) {\n    background: $grey-100;\n  }\n}\n\n.toggleActive {\n  background: $primary;\n  border-color: $primary;\n  color: $white;\n  font-weight: 600;\n}\n\n// ─── Pill strip ─────────────────────────────────────────────────────────────\n\n.pillStrip {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.pill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  min-width: 56px;\n  padding: 4px 8px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: $border-radius;\n  cursor: pointer;\n  transition: background 0.1s ease, border-color 0.1s ease, transform 0.1s ease;\n\n  &:hover:not(:disabled):not(.active) {\n    background: $grey-100;\n    border-color: $grey-300;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.45;\n  }\n}\n\n.active {\n  background: $primary;\n  border-color: $primary;\n  transform: translateY(-1px);\n\n  .pillLabel { color: $white; }\n  .pillCount { color: rgba(255, 255, 255, 0.85); }\n}\n\n.pillLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: $grey-400;\n  line-height: 1;\n}\n\n.pillCount {\n  font-size: 10px;\n  font-family: monospace;\n  color: $grey-300;\n  line-height: 1;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `CalendarControls_wrap__JXA3z`,
	"row": `CalendarControls_row__JBXw1`,
	"label": `CalendarControls_label__1qaUY`,
	"toggle": `CalendarControls_toggle__hJxOb`,
	"toggleActive": `CalendarControls_toggleActive__dpDa3`,
	"pillStrip": `CalendarControls_pillStrip__MF33G`,
	"pill": `CalendarControls_pill__aaySI`,
	"active": `CalendarControls_active__dBlIg`,
	"pillLabel": `CalendarControls_pillLabel__ilmvj`,
	"pillCount": `CalendarControls_pillCount__+TTJ5`
};
export default ___CSS_LOADER_EXPORT___;
